import { REACT_APP_API_URL } from '../../setup/config';
import axios, { handleApiError } from '../axios';

export const getCheques = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/cheques/`, data);
        return await response.data.data;
    } catch (error) {
        console.log("getCheques - error", error)
        return handleApiError(error)
    }
}

export const getChequeById = async (chequeId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/cheques/${chequeId}`);
        return await response.data;
    } catch (error) {
        console.log("getChequeById - error", error)
        return handleApiError(error)
    }
}

export const insertCheque = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/cheques/insert`, data);
        return await response.data;
    } catch (error) {
        console.log("insertCheque - error", error)
        return handleApiError(error)
    }
}

export const updateRealisedDate = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/cheques/realised-date`, data);
        return await response.data;
    } catch (error) {
        console.log("updateRealisedDate - error", error)
        return handleApiError(error)
    }
}

export const getChequeByChequeBookId = async (chequeBookId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/cheques/chequeBook/${chequeBookId}`);
        return await response.data;
    } catch (error) {
        console.log("getChequeById - error", error)
        return handleApiError(error)
    }
}

export const updateChequeStatus = async (chequeNo, data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/cheques/update/${chequeNo}`, data);
        return await response.data;
    } catch (error) {
        console.log("updateChequeStatus - error", error)
        return handleApiError(error)
    }
}